import React, { useEffect, useState } from "react";
import axios from "../axios";
import { Table, Tag } from "antd";

export default function TutorSubscriptionHistory({ tutorId }) {
  const [loading, setLoading] = useState(true);
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);
  const [page, setPage] = useState(1);
  const TABLE_LIMIT = 10;

  useEffect(() => {
    if (!tutorId) return;

    setLoading(true);
    // Fetch both current and past, then merge into a single array for the table
    Promise.all([
      axios.get(`/v1/cre/tutor/current-subscription?userId=${tutorId}`),
      axios.get(`/v1/cre/tutor/expired-subscriptions?userId=${tutorId}`),
    ])
      .then(([currentApiRes, pastApiRes]) => {
        const current = currentApiRes.data;
        const past = pastApiRes.data;

        let combined = [];
        let currentSubId = null;

        // Build array element for current subscription
        if (current?.is_success && current?.data) {
          const currSub = current.data;
          currentSubId = currSub.id;
          let planName = `HomeShiksha ${currSub.plan?.id === 5 ? "Premium" : "Basic"} Plan`;
          combined.push({
            id: currSub.id || "current",
            status: currSub.status_code || "ACTIVE",
            start_date: currSub.start_date || currSub.created_at,
            end_date: currSub.expiry_at,
            plan_name: planName,
            amount: currSub.plan?.amount || 0,
          });
        }

        // Build array elements for past subscriptions, excluding current to avoid duplicates
        if (past?.is_success && past?.data) {
          const pastList = past.data
            .filter((sub) => sub.subscription_id !== currentSubId)
            .map((sub) => {
              let planName = `HomeShiksha ${sub.plan?.id === 5 ? "Premium" : "Basic"} Plan`;
              return {
                id: sub.id,
                status: sub.status || "EXPIRED",
                start_date: sub.start_date,
                end_date: sub.end_date,
                plan_name: planName,
                amount: sub.plan?.amount || 0,
              };
            });
          combined = [...combined, ...pastList];
        }

        setSubscriptionHistory(combined);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Subscription fetch error:", error);
        setLoading(false);
      });
  }, [tutorId]);

  const columns = [
    {
      title: "Plan Name",
      dataIndex: "plan_name",
      key: "plan_name",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `₹${amount}/-`,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={status === "ACTIVE" ? "green" : status === "EXPIRED" || status === "FAILURE" ? "red" : "default"}
          key={status}
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "Subscription Start Date",
      dataIndex: "start_date",
      key: "start_date",
      render: (date) => (date ? date.split("T")[0] : "N/A"),
    },
    {
      title: "Subscription End Date",
      dataIndex: "end_date",
      key: "end_date",
      render: (date) => (date ? date.split("T")[0] : "N/A"),
    },
  ];

  return (
    <div style={{ marginTop: "24px" }}>
      <Table
        dataSource={subscriptionHistory}
        columns={columns}
        rowKey="id"
        loading={loading}
        scroll={{ x: "100%" }}
        pagination={{
          pageSize: TABLE_LIMIT,
          onChange: (page) => setPage(page),
          showSizeChanger: false,
          current: page,
        }}
        bordered={true}
      />
    </div>
  );
}
